import type { Props } from './types';

const LayoutGetTestTokens = ({ children }: Props) => {
  return (
    children
  );
};

export default LayoutGetTestTokens;
